import React, { useState, useEffect, useMemo } from "react";
import DrawerConfig from "../modules/main/Navigation/drawer-config";
import { FeatureAccess } from "../services/AuthService";

export default function useDrawerConfig() {
  const [accessibleFeatures, setAccessibleFeatures] = useState<string[]>([]);
  const [routes, setRoutes] = useState<any[]>([]);

  useEffect(() => {
    const fetchFeatureAccess = async () => {
      try {
        const token = localStorage.getItem("token");

        if (!token) {
          throw new Error("Token is not available. Please log in.");
        }

        const featureAccess = await FeatureAccess(token);
        if (Array.isArray(featureAccess.result)) {
          const features = featureAccess.result.map(
            (f: { featureId: number; featureDesc: string }) => f.featureDesc
          );
          setAccessibleFeatures(features);
        } else {
          console.error("Unexpected result format:", featureAccess.result);
          setAccessibleFeatures([]);
        }
      } catch (error) {
        console.error("Error fetching feature access", error);
        setAccessibleFeatures([]);
      }
    };

    fetchFeatureAccess();
  }, []);

  const filteredRoutes = useMemo(() => {
    if (accessibleFeatures.length === 0) {
      return [];
    }

    return DrawerConfig.Common.map(route => {
      if (route.children) {
        // Filter children based on accessible features
        route.children = route.children.filter(child =>
          child.feature && accessibleFeatures.includes(child.feature)
        );
      }

      // ✅ Keep the route if it has valid children OR if it has a feature itself
      if ((route.children && route.children.length > 0) || (route.feature && accessibleFeatures.includes(route.feature))) {
        return route;
      }

      return null; // Remove routes that have no accessible children and no feature itself
    }).filter(Boolean);
  }, [accessibleFeatures]);

  return filteredRoutes;
}
